import { Injectable } from '@angular/core';
import { GridApi, ColumnApi } from 'ag-grid-community';
import { GridName } from '../model/ag-grid-common-constant';

@Injectable({
  providedIn: 'root'
})
export class AgGridResponsiveService {
    companyName    = 'companyName';
    icon           = 'icon';
    vendorName     = 'vendorName';
    isExpandable   = 'isExpandable';
    fullName       = 'fullName';
    reqNo          = 'reqNo';
    sourcingNo     = 'sourcingNo';

  updateGridView(deviceWidth: number, gridApi: GridApi, columnApi: ColumnApi,storageName?:any): void {
    if (!gridApi || !columnApi) return;
    let value =  GridName.CONTACTRECYCLE == storageName
    if (deviceWidth < 1200) {
      columnApi.setColumnPinned(this.companyName, null);
      columnApi.setColumnPinned(this.icon, null);
      columnApi.setColumnPinned(this.vendorName, null);
      columnApi.setColumnPinned(this.isExpandable, null);
      columnApi.setColumnPinned(this.fullName, null);
      columnApi.setColumnPinned(this.reqNo, null);
      columnApi.setColumnPinned(this.sourcingNo, null);
        gridApi.refreshCells({
          columns: [this.companyName, this.icon, this.vendorName, this.isExpandable,this.fullName, this.reqNo, this.sourcingNo],
          force: true
        });
    } else {
      columnApi.setColumnPinned(this.companyName,value? null: 'left');
      columnApi.setColumnPinned(this.icon, 'left');
      columnApi.setColumnPinned(this.vendorName, 'left');
      columnApi.setColumnPinned(this.fullName,  'left');
      columnApi.setColumnPinned(this.reqNo, 'left');
      columnApi.setColumnPinned(this.sourcingNo, 'left');
      gridApi.refreshCells({
        columns: [this.companyName, this.icon, this.vendorName, this.isExpandable,this.fullName, this.reqNo, this.sourcingNo],
        force: true
      });
    }
    gridApi.refreshCells({ force: true });
  }
}
